export default __webpack_public_path__ + "static/media/kenzie-academy.f2d1deac.svg";